import { ecboClient, getHeaderLocale } from 'lib/axios'

import type { Facility } from 'features/facility/types/facility'

const API_FACILITY_RECOMMENDATIONS = '/api/web/facilities/recommendations'

export type FacilityRecommendationsParams = {
  latitude: number
  longitude: number
  type: 'city' | 'station'
  prefecture_id: number
  locale: string
}

export const fetchFacilityRecommendations = async (
  params: FacilityRecommendationsParams
): Promise<Facility[]> => {
  const response = await ecboClient.get<Facility[]>(API_FACILITY_RECOMMENDATIONS, {
    params: {
      latitude: params.latitude,
      longitude: params.longitude,
      type: params.type,
      prefecture_id: params.prefecture_id,
    },
    headers: { 'Accept-Language': getHeaderLocale(params.locale) },
  })

  return response.data
}
